(() => {
  if (window.ventanaCookiePreferencesBound) return;
  window.ventanaCookiePreferencesBound = true;
  let opener;
  let apiPromise;
  const getApi = () => {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (apiPromise) return apiPromise;
    apiPromise = new Promise((resolve, reject) => {
      if (!window.Shopify?.loadFeatures) { reject(new Error('Unavailable')); return; }
      const timeout = setTimeout(() => reject(new Error('Timeout')), 10000);
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
        clearTimeout(timeout);
        if (error || !window.Shopify.customerPrivacy) reject(new Error('Unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      });
    }).catch(error => { apiPromise = null; throw error; });
    return apiPromise;
  };
  const setBusy = (dialog, busy) => {
    dialog.querySelectorAll('[data-vc-consent-action]').forEach(button => { button.disabled = busy; });
    dialog.setAttribute('aria-busy', String(busy));
  };
  const open = async trigger => {
    const dialog = document.getElementById('VcCookiePreferences');
    if (!dialog) return;
    opener = trigger;
    const status = dialog.querySelector('[role=status]');
    if (!dialog.open) dialog.showModal();
    setBusy(dialog, true);
    status.textContent = dialog.dataset.loading;
    try {
      const api = await getApi();
      const consent = api.currentVisitorConsent();
      ['preferences', 'analytics', 'marketing'].forEach(key => {
        dialog.querySelector(`input[name="${key}"]`).checked = consent[key] === 'yes';
      });
      status.textContent = '';
      setBusy(dialog, false);
    } catch { status.textContent = dialog.dataset.error; }
  };
  const save = async (dialog, mode) => {
    const status = dialog.querySelector('[role=status]');
    setBusy(dialog, true);
    status.textContent = dialog.dataset.loading;
    const choice = Object.fromEntries(['preferences', 'analytics', 'marketing'].map(key => [key, mode === 'accept' || (mode === 'save' && dialog.querySelector(`input[name="${key}"]`).checked)]));
    try {
      const api = await getApi();
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('Timeout')), 10000);
        api.setTrackingConsent(choice, result => {
          clearTimeout(timeout);
          if (result?.error) reject(new Error('Failed'));
          else resolve();
        });
      });
      const stored = api.currentVisitorConsent();
      const matched = Object.entries(choice).every(([key, value]) => stored[key] === (value ? 'yes' : 'no'));
      if (!matched) throw new Error('Not saved');
      Object.entries(choice).forEach(([key, value]) => { dialog.querySelector(`input[name="${key}"]`).checked = value; });
      status.textContent = dialog.dataset.saved;
    } catch { status.textContent = dialog.dataset.error; }
    finally { setBusy(dialog, false); }
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-vc-open-consent]');
    if (trigger) { event.preventDefault(); open(trigger); return; }
    const dialog = event.target.closest('#VcCookiePreferences');
    if (!dialog) return;
    if (event.target.closest('[data-vc-consent-close]')) dialog.close();
    const action = event.target.closest('[data-vc-consent-action]');
    if (action && action.type !== 'submit') save(dialog, action.dataset.vcConsentAction);
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-vc-consent-form]')) return;
    event.preventDefault();
    save(event.target.closest('dialog'), 'save');
  });
  document.addEventListener('close', event => {
    if (event.target.id === 'VcCookiePreferences' && opener?.isConnected) opener.focus();
  }, true);
})();
